const getInitialState = () => ({
  hints_float_namespace: 'tra/alpha',
})
// const state = getInqitialState()

const getters = {
  hints_float_namespace: state => state.hints_float_namespace,
  hints_props_float: (state, getters) => {
    const nn = state.hints_float_namespace

    const qqfh = getters[`${nn}/query_fullhand_setup`]
    const overviewSpot = getters[`${nn}/trainer_overview_spot`]
    const infoVisible = getters[`${nn}/trainer_info_visible`]
    const gameformat = getters[`${nn}/gameformat`]
    const solElite = getters[`${nn}/sol_elite`]

    const res = {
      namespace: nn,
      spot: overviewSpot,
      pref: {
        fh_trainer_learning_mode: qqfh.fh_trainer_learning_mode,
        fh_trainer_hero_range: qqfh.fh_trainer_hero_range,
        fh_trainer_opponent_range: qqfh.fh_trainer_opponent_range,
        fh_trainer_ranges_comparison: qqfh.fh_trainer_ranges_comparison,
        fh_trainer_hand_strength: qqfh.fh_trainer_hand_strength,
        fh_trainer_total_frequency: qqfh.fh_trainer_total_frequency,
        fh_trainer_category_hands: qqfh.fh_trainer_category_hands,
        fh_trainer_category_draws: qqfh.fh_trainer_category_draws,
        fh_trainer_hero_strategy: qqfh.fh_trainer_hero_strategy,
        fh_trainer_equity_chart: qqfh.fh_trainer_equity_chart,
      },
      grouping: 'swv_grouping_none',
      isICM:
        (solElite?.want_use && solElite.tournamentType === 'icm') ||
        (gameformat?.format === 'icm' && !solElite?.want_use),
      infoVisible, // learning mode
    }
    // console.log(res, solElite)
    return res
  },
  hints_props_namespace: (state, getters) => {
    const nn = getters.active_namespace

    const qqfh = getters[`${nn}/query_fullhand_setup`]
    const overviewSpot = getters[`${nn}/trainer_overview_spot`]
    const infoVisible = getters[`${nn}/trainer_info_visible`]
    const gameformat = getters[`${nn}/gameformat`]
    const solElite = getters[`${nn}/sol_elite`]

    const res = {
      namespace: nn,
      spot: overviewSpot,
      pref: {
        fh_trainer_learning_mode: qqfh.fh_trainer_learning_mode,
        fh_trainer_hero_range: qqfh.fh_trainer_hero_range,
        fh_trainer_opponent_range: qqfh.fh_trainer_opponent_range,
        fh_trainer_ranges_comparison: qqfh.fh_trainer_ranges_comparison,
        fh_trainer_hand_strength: qqfh.fh_trainer_hand_strength,
        fh_trainer_total_frequency: qqfh.fh_trainer_total_frequency,
        fh_trainer_category_hands: qqfh.fh_trainer_category_hands,
        fh_trainer_category_draws: qqfh.fh_trainer_category_draws,
        fh_trainer_hero_strategy: qqfh.fh_trainer_hero_strategy,
        fh_trainer_equity_chart: qqfh.fh_trainer_equity_chart,
      },
      grouping: 'swv_grouping_none',
      isICM:
        (solElite?.want_use && solElite.tournamentType === 'icm') ||
        (gameformat?.format === 'icm' && !solElite?.want_use),
      infoVisible, // learning mode
    }
    // console.log(res, solElite)
    return res
  },
}

const actions = {}
const mutations = {
  hints_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
